import { getCountryPending, getCountrySuccess, getCountryFail, 
    deleteCountryPending, deleteCountrySuccess, deleteCountryFail,
    createCountryPending,createCountrySuccess,createCountryFail } from "./countryListSlice";
import { fetchAllCountry, countryDelete,countryCreation } from "../../../api/userApi";

export const getAllCountry = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getCountryPending());
        const result = await fetchAllCountry();
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);

       // console.log('countryData ' + myJSON);
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const roledetails = JSON.parse(JSON.stringify(myObj.countries));
        const roledetails1 = JSON.parse(JSON.stringify(roledetails));
        //console.log('us '+roledetails1[0].id);
        //console.log('getuserpending '+result.userroles[0].id);
        /* console.log('getuserpending user '+result.user[0].firstName);
        console.log('getuserpending fname '+result.lastName);
        console.log('getuserpending lname '+result.user.lastName); */
        //console.log('check user profile out if');
        if (roledetails) {
            //console.log('check user profile');
            return dispatch(getCountrySuccess(roledetails));
        }
        dispatch(getCountryFail("User is not found"));


    } catch (error) {
      //  console.log(error)
        dispatch(getCountryFail(error));

    }
}


export const countryDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteCountryPending());
        const result = await countryDelete(frmDt);
      
        result.status ==="success" 
        ? dispatch(deleteCountrySuccess("Country deleted"))
        : dispatch(deleteCountryFail(result.message));
        
    } catch (error) {
       
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       
        dispatch(deleteCountryFail(err.msg));
    }
    
}

